<app-bell-plus [ngClass]="{'bell-disabled':proposta.possuiSosInversoEmAberto, 'bell-enabled': !proposta.possuiSosInversoEmAberto }" class="" (onClick)="abrirModalSOS()"></app-bell-plus>

<app-modal #modalSosInverso title="ENVIO DE SOS" labelOk="ENVIAR SOS" labelClose="Cancelar" [ignoreBackdropClick]="true" [keyboard]="false" [disabledOk]="!isCamposPreenchidos()">
    <div class="modal-sos-inverso forms">
        <h3>MOTIVO</h3>
        <app-custom-select [items]="motivos" (itemChange)="sosInverso.idMotivo = $event"></app-custom-select>

        <h3>OBSERVAÇÃO</h3>
        <div class="textarea-observacoes">
            <textarea [(ngModel)]="sosInverso.observacao" class="form-control" maxlength="500" rows="10" cols="50" placeholder="Inserir observações" name="observacao" required></textarea>
        </div>
    </div>
</app-modal>

<app-loader-circles *ngIf="isLoading"></app-loader-circles>
